import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ToBottomIcon } from '../icons';
import { ToolbarButton } from '../ui';
import { moveObjectsToBottom } from '../project';
import { getCurrentPieceID } from '../stage';
import { getSelectedObjectsIDs } from '../editor';

const ButtonMoveToBottom = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }

  return <ToolbarButton icon={<ToBottomIcon />} onClick={onClick} />;
};

ButtonMoveToBottom.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    const pieceID = getCurrentPieceID(state);
    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size > 0) {
      disabled = false;
    }
    return { ids, disabled, pieceID };
  },
  { moveObjectsToBottom },
  ({ ids, pieceID, ...state }, actions) => ({
    ...state,
    onClick: () => actions.moveObjectsToBottom({ pieceID, ids }),
  }),
);

export default reduxConnector(ButtonMoveToBottom);
